module.exports = __webpack_public_path__ + "static/media/Trailer36FT.c082de8d.svg";